import React from 'react';

// Deterministic irregular field: stable across routes and refreshes, no tiled dots.
const points = Array.from({ length: 89 }, (_, i) => {
  const noise = (seed: number) => { const n = Math.sin(seed * 127.1 + 311.7) * 43758.5453; return n - Math.floor(n); };
  return { x: 2 + noise(i + 1) * 96, y: 3 + noise(i + 98) * 94, r: i % 19 === 0 ? 1.4 : i % 7 === 0 ? .8 : .35, opacity: .09 + noise(i + 204) * .28 };
});

export function UniverseAtmosphere() {
  return <svg className="universe-atmosphere" viewBox="0 0 1200 800" preserveAspectRatio="none" aria-hidden="true">
    {points.map((point, i) => i % 19 === 0 ? <path key={i} opacity={point.opacity} d={`M${point.x * 12} ${point.y * 8 - 4}q0 4 4 4q-4 0-4 4q0-4-4-4q4 0 4-4Z`} /> : <circle key={i} cx={point.x * 12} cy={point.y * 8} r={point.r} opacity={point.opacity} />)}
  </svg>;
}
